import { action } from "satcheljs";

export interface SWEEP_DIALOG_ON_MOVE_TO_FOLDER_CLICKActionMessage {
    folderId: string;
}
const defaultExport: (folderId: string) => SWEEP_DIALOG_ON_MOVE_TO_FOLDER_CLICKActionMessage = action("SWEEP_DIALOG_ON_MOVE_TO_FOLDER_CLICK", (folderId: string): SWEEP_DIALOG_ON_MOVE_TO_FOLDER_CLICKActionMessage => ({
    folderId,
}));
export default defaultExport;
